import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./layout/Layout";
import PrivateRoute from "./routes/PrivateRoute";
import PrivateLayout from "./layout/PrivateLayout";
import OTPVerification from "./features/Home/OTPVerification";
import EditProfile from "./features/setting/EditProfile";
import Login from "./features/Home/Login";
import Plans from "./features/plan/Plans";
import MyBooking from "./features/bookings/MyBooking";
import Report from "./features/report/Report";
import BookingDetail from "./features/bookings/BookingDetail";

let basename="/user/"

if(process.env.NODE_ENV==="production"){
  basename="/houzez/website/"
}

function App() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route
          path="/plan"
          element={
            <PrivateRoute>
              <PrivateLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Plans />} />
        </Route>

        <Route
          path="/booking"
          element={
            <PrivateRoute>
              <PrivateLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<MyBooking />} />
          <Route path="detail/:id" element={<BookingDetail />} />
        </Route>

        <Route
          path="/report"
          element={
            <PrivateRoute>
              <PrivateLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Report />} />
        </Route>

        <Route
          path="/edit-profile"
          element={
            <PrivateRoute>
              <PrivateLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<EditProfile />} />
        </Route>

        <Route path="/" element={<Layout />}>
          <Route index element={<Login />} />
        </Route>

        <Route path="/otp-verification" element={<OTPVerification />}>
          <Route index element={<OTPVerification />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
